// extracted by mini-css-extract-plugin
export var banner = "_31-0";
export var icon = "_31-1";
export var message = "_31-2";